// Bearer header for NotesAI backend endpoints that verify the caller
// (Master Note, AI assistant chat). The backend derives the user from this
// token and ignores any userId / username / userJwtToken in the body.
import { getSupabase } from "../components/supabaseClient";

export async function bearerAuthHeaders() {
  try {
    const sb = await getSupabase();
    const {
      data: { session },
    } = await sb.auth.getSession();
    const token = session?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch (_) {
    return {};
  }
}
